<template>

    <form autocomplete="off" class="trax-form mb-4">

        <trax-ui-choice :placeholder="lang.polaris.dashboard.result" col="md-3"
            v-model="form.success" :error="errors.success" :options="success_select" required="1">
        </trax-ui-choice>

        <trax-ui-input :placeholder="lang.polaris.dashboard.comments" col="md-3"
            v-model="form.comments" :error="errors.comments" rows="5">
        </trax-ui-input>

        <trax-ui-toggle :text="lang.polaris.dashboard.atp_needed" col="md-3" 
            v-model="form.procedure">
        </trax-ui-toggle>

    </form>

</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-flight-progress-check-learner-edit'},
            source: {default: '4'},
            target: {default: 'final'}
        },

        data: function() {
            return {
                lang: lang,
                form: {
                    success: '',
                    comments: '',
                    procedure: 0,
                },
                success_select: [
                    {value: 3, name: lang.polaris.dashboard.pass, color: 'success'},
                    {value: 1, name: lang.polaris.dashboard.fail, color: 'danger'},
                ],
                errors: {},
                bus: this.$bus
            }
        },
        
        created: function() {
            this.bus.$on(this.id+'-states-data', this.setStates);
            this.bus.$on(this.id+'-states-updated', this.setStates);
            this.bus.$on(this.id+'-'+this.source+'-states-save', this.saveData);
            this.bus.$on(this.id+'-states-errors', this.setErrors);
        },

        methods: {

            setStates(states) {
                if (!states.summary) {
                    this.form.success = '';
                    this.form.comments = '';
                    this.form.procedure = 0;
                    return;
                }
                this.form.success = states.summary.data.success;
                this.form.comments = states.summary.data.comments;
                this.form.procedure = states.summary.data.procedure;
            },

            setErrors(errors) {
                var my_errors = {};
                for (var index in errors) {
                    my_errors[index.split('.')[1]] = errors[index];
                }
                this.errors = my_errors;
            },

            saveData(data) {
                this.errors = {};
                for (var prop in this.form) { data.summary[prop] = this.form[prop]; }
                this.bus.$emit(this.id+'-'+this.target+'-states-save', data);
            }
        }
    }
</script>
